import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  readAdminCustomerRouteParam,
  readRouteParam,
} from '../../../_utils/route-param.utils';
import { TranslateModule } from '@ngx-translate/core';
import IProduct from '../../../_interfaces/IProduct';
import { AdminEntityLoaderService } from '../../../_services/admin/admin-entity-loader.service';
import { AdminFormLayoutComponent } from '../../../components/admin-ui/admin-form-layout/admin-form-layout.component';
import { AdminPageHeaderComponent } from '../../../components/admin-ui/admin-page-header/admin-page-header.component';
import { AdminStatePanelComponent } from '../../../components/admin-ui/admin-state-panel/admin-state-panel.component';
import { FormProductsComponent } from '../../../components/forms/form-products/form-products.component';

@Component({
  selector: 'app-admin-product-detail',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AdminPageHeaderComponent,
    AdminStatePanelComponent,
    AdminFormLayoutComponent,
    FormProductsComponent,
  ],
  templateUrl: './admin-product-detail.component.html',
  styleUrl: './admin-product-detail.component.scss',
})
export class AdminProductDetailComponent implements OnInit {
  public customersId = 0;
  public productsId = 0;
  public product: IProduct | null = null;
  public loading = true;
  public hasError = false;
  readonly reload = (): void => this.load();

  constructor(
    private readonly route: ActivatedRoute,
    private readonly loader: AdminEntityLoaderService,
  ) {}

  get backLink(): any[] {
    return [
      '/administration',
      readAdminCustomerRouteParam(this.route, this.customersId) || this.customersId,
      'products',
    ];
  }

  ngOnInit(): void {
    this.customersId = readRouteParam(this.route, 'customers_id');
    this.productsId = readRouteParam(this.route, 'products_id');
    this.load(true);
  }

  load(fromResolver = false): void {
    this.loading = true;
    this.hasError = false;

    if (fromResolver) {
      const product = (this.route.snapshot.data['product'] || null) as
        | IProduct
        | null;
      if (product) {
        this.product = product;
        this.loading = false;
        return;
      }
    }

    this.loader.loadProduct(this.customersId, this.productsId).subscribe({
      next: (product) => {
        this.product = product;
        this.hasError = !product;
        this.loading = false;
      },
      error: () => {
        this.hasError = true;
        this.loading = false;
      },
    });
  }
}
